import { createUseStyles } from 'react-jss'

import { colors, zIndexes } from '../variables.style'

const TOC_WIDTH = 600

export const style = {
  tocMenuFloat: {
    position: 'fixed',
    top: 0,
    height: '100vh',
    zIndex: zIndexes.dropdownMenu,
    pointerEvents: 'none'
  },
  centerVertically: {
    composes: 'flex-row flex-center-items',
    height: 'inherit',
    position: 'absolute',
    top: 0
  },
  tocMenuButton: {
    composes: 'flex-row',
    alignItems: 'center',
    backgroundColor: colors.backgroundGray,
    border: `1px solid ${colors.gunMetal}`,
    borderTop: 'none',
    color: colors.gunMetal,
    cursor: 'pointer',
    pointerEvents: 'auto',
    transform: 'rotateZ(270deg)',
    marginLeft: -71,
    '&:hover, &:focus': {
      backgroundColor: colors.metallicSeaweed,
      borderColor: colors.metallicSeaweed,
      color: 'white'
    }
  },
  tocMenuIcon: {
    composes: 'font-icon-toc',
    fontSize: 40,
    marginTop: 1,
    marginLeft: 5
  },
  tocMenuLabel: {
    padding: '0 14px 5px 4px',
    whiteSpace: 'nowrap'
  },
  tocListContainer: {
    position: 'absolute',
    left: -TOC_WIDTH,
    width: TOC_WIDTH,
    padding: 40,
    backgroundColor: colors.backgroundGray,
    border: `1px solid ${colors.gunMetal}`,
    borderLeft: 'none',
    overflowY: 'auto',
    maxHeight: '100vh',
    pointerEvents: 'auto'
  },
  executiveSummaryLink: {
    position: 'absolute',
    top: 20,
    left: 40
  },
  close: {
    composes: 'font-icon-close',
    position: 'absolute',
    top: 0,
    right: 0,
    padding: '12px 15px',
    fontSize: 24,
    cursor: 'pointer',
    '&:hover, &:focus': {
      color: colors.oriolesOrange
    }
  },
  tocList: {
    marginBottom: 30 // compensate for lack of padding-bottom on FF
  }
}

export const useStyles = createUseStyles(style)
